<template>
  <!-- Group Header -->
  <tr class="group-row">
    <td></td>
    <td>
      <v-icon @click="$emit('toggle')">{{ expanded ? "mdi-minus" : "mdi-plus" }}</v-icon>
    </td>
    <td colspan="10" class="name-column">
      {{ isUngrouped ? "Ungrouped" : name }}
    </td>
  </tr>
</template>

<script>
export default {
  name: "QuoteFolderHeader",
  props: {
    name: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: "",
    },
    count: {
      type: Number,
      default: 0,
    },
    expanded: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isUngrouped() {
      return this.name === "ungrouped";
    },
  },
};
</script>

<style scoped>
.group-row {
  background-color: #e2f0f4;
}
.group-row td {
  border-bottom: thin solid;
}
.name-column {
  font-weight: bold;
}
</style>
